export const NAME = 'CONSULTATION';

export const getConsultationBooking = (store) => store[NAME].create;
